module.exports = __webpack_public_path__ + "img/bg_avatar_female_94.2ca587c0.png";